/**
 * Базовый класс сервисов платформы
 */
export class BaseService {

	/**
	 * Объект содержащий ключ/значение уровня логов
	 */
	static LogLevels = {
		INFO: 1,
		DEBUG: 2,
		WARNING: 3,
		ERROR: 4
	};

	/**
	 * Базовая функция выполняющая запрос с предварительной обработкой ответа.
	 * @param {String} url Адрес 
	 * @param {Object} headers Объект с дополнительными заголовками запроса ( заголовок авторизации указан по умолчанию )
	 * @param {Object} body Тело запроса. Указывается ( если необходимо ) при методах запроса отличных от GET.
	 * @param {Boolean} notConvertBody Флаг запрещающий конвертацию тела запроса в JSON (применяется при отправки FormData)
	 * @returns Промис с ответом на запрос
	 */
	static async baseHandle(url, methodType = "GET", headers, body = null, notConvertBody) {

		const result = await fetch(url, {
			headers: {
				'Authorization': `Bearer ${localStorage.getItem('token')}`,
				...headers
			},
			method: methodType,
			body: !!body && typeof (body) === 'object' && !notConvertBody ? JSON.stringify(body) : body
		});

		const responseType = result.headers.get("Content-Type");

		let mr = {
			success: result.ok,
			data: result,
			message: `Запрос '${url}' вернул следующий результат - ${result.status} ( ${result.statusText} )`
		};

		if (!!responseType) {
			if (responseType.includes("application/json;"))
				mr.data = await result.json();
			else if (responseType.includes("application/octet-stream") || responseType.includes("application/x-msdownload"))
				mr.data = await result.blob();
			else if (responseType.includes("text/html"))
				mr.data = await result.text();
		}

		mr.status = result.status;
		return mr;
	}

	/**
	 * Функция создает запись в таблицу логов
	 * @param {String} objectName Наименование объект вызвавший событие 
	 * ( по умолчанию - RdevService)
	 * @param {String} message Сообщение
	 * @param {LogLevels} logLevel Тип лога 
	 * @param {Any} data Дополнительные данные
	 */
	static writeLog(objectName = 'RdevService', senderID = null, message, logLevel, data) {

		switch (logLevel) {
			case 3:
				console.warn(message, data);
				break
			case 4:
				console.error(message, data);
				break;
			case 1:
			case 2:
			default:
				console.log(message, data);
				break;
		}

		const body = {
			objectname: objectName,
			objectid: senderID,
			message: message ? message.toString() : '',
			data: !!data ? JSON.stringify(data) : "",
			eventtype: logLevel,
			closed: false
		};

		const req = {
			headers: {
				'Authorization': `Bearer ${localStorage.getItem('token')}`,
				'Content-Type': 'application/json; odata=verbose'
			},
			method: 'POST',
			body: JSON.stringify(body)
		};

		return fetch("/events/createlog", req);
	}

	static returnResponse(response) {
		if(response.status === 200)
			return Promise.resolve(response.data);

		throw !!response.data ? response.data : response.message;
	}
	
}
